'use client';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import "../../../styles/Home/Testimony/testimony.css"
import { TestimonyItem } from './TestimonyItem';

const Testimony: FC = () => {
  const intl = useIntl();

  const items = [
    {
      id: 'tanrise',
      name: 'Tanrise',
      division: intl.formatMessage({ id: 'TESTIMONY.ITEM1.DIVISION' }),
      number: '100%',
      title: intl.formatMessage({ id: 'TESTIMONY.ITEM1.TITLE' }),
      description: intl.formatMessage({ id: 'TESTIMONY.ITEM1.DESCRIPTION' }),
    },
    {
      id: 'kawasaki',
      name: 'Kawasaki',
      division: intl.formatMessage({ id: 'TESTIMONY.ITEM2.DIVISION' }),
      number: '2X',
      title: intl.formatMessage({ id: 'TESTIMONY.ITEM2.TITLE' }),
      description: intl.formatMessage({ id: 'TESTIMONY.ITEM2.DESCRIPTION' }),
    },
    {
      id: 'mdc',
      name: 'MDC School',
      division: intl.formatMessage({ id: 'TESTIMONY.ITEM3.DIVISION' }),
      number: '5X',
      title: intl.formatMessage({ id: 'TESTIMONY.ITEM3.TITLE' }),
      description: intl.formatMessage({ id: 'TESTIMONY.ITEM3.DESCRIPTION' }),
    },
    {
      id: 'borneo',
      name: 'Borneo Lancar Abadi',
      division: intl.formatMessage({ id: 'TESTIMONY.ITEM4.DIVISION' }),
      number: '90%',
      title: intl.formatMessage({ id: 'TESTIMONY.ITEM4.TITLE' }),
      description: intl.formatMessage({ id: 'TESTIMONY.ITEM4.DESCRIPTION' }),
    },
  ];

  return (
    <div className="container-fluid bg-benefits p-5 px-4 px-md-5 container-vertical-padding sora mb-5 scroll-reveal">
      <div className={`mx-auto`}>
        <h1
          className="fw-bold mb-0 mt-lg-4"
          dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'TESTIMONY.HEADER' }) }}
          style={{ lineHeight: 1.5 }}
        ></h1>
        <h1
          className="fw-bold"
          dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'TESTIMONY.HEADER2' }) }}
          style={{ lineHeight: 1.5 }}
        ></h1>
      </div>
      <div className="d-flex justify-content-center mx-auto" style={{ maxWidth: '1200px' }}>
        <div className="row pt-5 w-100 text-start">
          {items.map(item => (
            <div className="col-12 col-md-6 mb-4 d-flex" key={item.id}>
              <TestimonyItem item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export { Testimony };
